import { SpriteTypes, spriteCategory } from '../types/sprite-types'
import { uuid } from '@/libs/src/utils/tools'
const options = {
    visible: true,
    width: 100,
    height: 100,
    name: "image",
    lineWidth: 0, radio: true, imageRatio: true,isBottom:true,disableAnchor:true,
}

export default [
    {
        id: uuid(),
        name: "PAC",
        type: SpriteTypes.sprite,
        image: "images/imgs/PAC.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/PAC.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "电解除磷",
        type: SpriteTypes.sprite,
        image: "images/imgs/1.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/1.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "调节池",
        type: SpriteTypes.sprite,
        image: "images/imgs/2.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/2.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "阀门1（1）",
        type: SpriteTypes.sprite,
        image: "images/imgs/3.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/3.png",
            ...options
        },
    }, {
        id:uuid(),
        name: "阀门1",
        type: SpriteTypes.sprite,
        image: "images/imgs/4.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/4.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "阀门2",
        type: SpriteTypes.sprite,
        image: "images/imgs/5.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/5.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "风机（1）",
        type: SpriteTypes.sprite,
        image: "images/imgs/6.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/6.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "风机（2）",
        type: SpriteTypes.sprite,
        image: "images/imgs/7.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/7.png",
            ...options
        },
    },
    {
        id:uuid(),
        name: "风机",
        type: SpriteTypes.sprite,
        image: "images/imgs/8.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/8.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "计量泵",
        type: SpriteTypes.sprite,
        image: "images/imgs/9.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/9.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "搅拌阀",
        type: SpriteTypes.sprite,
        image: "images/imgs/10.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/10.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "搅拌机",
        type: SpriteTypes.sprite,
        image: "images/imgs/11.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/11.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "流量计1",
        type: SpriteTypes.sprite,
        image: "images/imgs/12.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/12.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "流量计2",
        type: SpriteTypes.sprite,
        image: "images/imgs/13.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/13.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "流量计3",
        type: SpriteTypes.sprite,
        image: "images/imgs/14.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/14.png",
            ...options
        },
    },{
        id:uuid(),
        name: "罐体",
        type: SpriteTypes.sprite,
        image: "images/imgs/15.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/15.png",
            ...options
        },
    },{
        id: uuid(),
        name: "曝气盘",
        type: SpriteTypes.sprite,
        image: "images/imgs/16.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/16.png",
            ...options
        },
    },{
        id: uuid(),
        name: "气泵",
        type: SpriteTypes.sprite,
        image: "images/imgs/17.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/17.png",
            ...options
        },
    },{
        id: uuid(),
        name: "生物海藻",
        type: SpriteTypes.sprite,
        image: "images/imgs/18.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/18.png",
            ...options
        },
    },{
        id: uuid(),
        name: "生物球",
        type: SpriteTypes.sprite,
        image: "images/imgs/19.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/19.png",
            ...options
        },
    },{
        id: uuid(),
        name: "水泵",
        type: SpriteTypes.sprite,
        image: "images/imgs/20.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/20.png",
            ...options
        },
    },{
        id: uuid(),
        name: "消毒槽",
        type: SpriteTypes.sprite,
        image: "images/imgs/21.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/21.png",
            ...options
        },
    },{
        id:uuid(),
        name: "循环泵1",
        type: SpriteTypes.sprite,
        image: "images/imgs/22.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/22.png",
            ...options
        },
    },{
        id:uuid(),
        name: "循环泵2",
        type: SpriteTypes.sprite,
        image: "images/imgs/23.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/23.png",
            ...options
        },
    },{
        id:uuid(),
        name: "循环泵3",
        type: SpriteTypes.sprite,
        image: "images/imgs/24.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/24.png",
            ...options
        },
    },{
        id:uuid(),
        name: "中国卧罐外观",
        type: SpriteTypes.sprite,
        image: "images/imgs/25.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/imgs/25.png",
            ...options
        },
    },{
        id:uuid(),
        name: "图形1",
        type: SpriteTypes.sprite,
        image: "images/img2/M1.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img2/M1.png",
            ...options
        },
    },{
        id:uuid(),
        name: "图形2",
        type: SpriteTypes.sprite,
        image: "images/img2/M.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img2/M.png",
            ...options
        },
    },{
        id:uuid(),
        name: "PAM",
        type: SpriteTypes.sprite,
        image: "images/img2/PAM.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img2/PAM.png",
            ...options
        },
    },{
        id:uuid(),
        name: "碳源",
        type: SpriteTypes.sprite,
        image: "images/img2/1.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img2/1.png",
            ...options
        },
    },{
        id:uuid(),
        name: "池体",
        type: SpriteTypes.sprite,
        image: "images/img2/pool1.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img2/pool1.png",
            ...options
        },
    },{
        id:uuid(),
        name: "状态",
        type: SpriteTypes.sprite,
        image: "images/img2/state.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img2/state.png",
            ...options
        },
    },
    {
        id:uuid(),
        name: "电磁阀",
        type: SpriteTypes.sprite,
        image: "images/img3/1.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img3/1.png",
            ...options
        },
    },
    {
        id:uuid(),
        name: "反洗泵",
        type: SpriteTypes.sprite,
        image: "images/img3/2.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img3/2.png",
            ...options
        },
    },{
        id:uuid(),
        name: "浮球",
        type: SpriteTypes.sprite,
        image: "images/img3/3.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img3/3.png",
            ...options
        },
    },{
        id:uuid(),
        name: "离心机",
        type: SpriteTypes.sprite,
        image: "images/img3/4.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img3/4.png",
            ...options
        },
    },{
        id:uuid(),
        name: "连杆浮球",
        type: SpriteTypes.sprite,
        image: "images/img3/5.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img3/5.png",
            ...options
        },
    },{
        id:uuid(),
        name: "流量计",
        type: SpriteTypes.sprite,
        image: "images/img3/6.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img3/6.png",
            ...options
        },
    },{
        id:uuid(),
        name: "泥泵",
        type: SpriteTypes.sprite,
        image: "images/img3/7.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img3/7.png",
            ...options
        },
    },{
        id:uuid(),
        name: "切割机",
        type: SpriteTypes.sprite,
        image: "images/img3/8.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img3/8.png",
            ...options
        },
    },{
        id:uuid(),
        name: "砂水分离器",
        type: SpriteTypes.sprite,
        image: "images/img3/9.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img3/9.png",
            ...options
        },
    },{
        id:uuid(),
        name: "污泥切割机",
        type: SpriteTypes.sprite,
        image: "images/img3/10.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img3/10.png",
            ...options
        },
    },{
        id:uuid(),
        name: "污泥脱水机",
        type: SpriteTypes.sprite,
        image: "images/img3/11.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/img3/11.png",
            ...options
        },
    }
]